module.exports = __webpack_public_path__ + "9e4c60fc819ae2569b06943ce2cfb1ba.svg";